import "@/App.css";
import axios from "axios";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Setup from "@/pages/Setup";
import Trick from "@/pages/Trick";
import TenOutsTrick from "@/pages/TenOutsTrick";
import Settings from "@/pages/Settings";
import Tutorial from "@/pages/Tutorial";
import DecoyNotes from "@/pages/DecoyNotes";
import Folders from "@/pages/Folders";
import CustomFolder from "@/pages/CustomFolder";
import RecentlyDeleted from "@/pages/RecentlyDeleted";
import LockScreen from "@/pages/LockScreen";
import Admin from "@/pages/Admin";
import Gate from "@/pages/Gate";
import { installAxiosAuth } from "@/lib/mr";
import { Toaster } from "sonner";

// Forward the cached password on every outgoing axios call
installAxiosAuth(axios);

/** Route resolver: /trick swaps between the regular note disguise and
 *  the Ten-Outs cycling page based on the navigation state.entry. Keeps
 *  React hook order stable inside each page component. */
function TrickRoute() {
  const location = useLocation();
  const entry = location.state?.entry;
  if (entry === "tenouts") return <TenOutsTrick />;
  return <Trick />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="*"
            element={
              <Gate>
                {/* iOS keyboard bridge — see openRow/openCompose in DecoyNotes.jsx
              and the autofocus useLayoutEffect in Trick.jsx. Tapping a
              note synchronously focuses this hidden <input> inside the
              touchend handler, which tells iOS Safari to start opening
              the virtual keyboard while still in the user-gesture
              window. The trick view then transfers that focus to the
              real title/body input on mount, keeping the keyboard up
              instead of dismissing it. Position fixed + opacity 0 +
              pointer-events none keeps it invisible & non-interactive. */}
                <input
                  id="kb-bridge"
                  data-testid="kb-bridge"
                  type="text"
                  aria-hidden="true"
                  tabIndex={-1}
                  readOnly
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: 1,
                    height: 1,
                    opacity: 0,
                    pointerEvents: "none",
                    border: "none",
                    padding: 0,
                    margin: 0,
                    fontSize: 16, // ≥16px avoids iOS zoom-on-focus side effect
                  }}
                />
                <Routes>
                  <Route path="/" element={<Setup />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/tutorial" element={<Tutorial />} />
                  <Route path="/notes" element={<DecoyNotes />} />
                  <Route path="/folders" element={<Folders />} />
                  <Route path="/folders/:id" element={<CustomFolder />} />
                  <Route path="/recently-deleted" element={<RecentlyDeleted />} />
                  <Route path="/lock" element={<LockScreen />} />
                  <Route path="/trick" element={<TrickRoute />} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </Gate>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </div>
  );
}

export default App;
